<mat-nav-list>
    <ng-container *ngFor="let item of navDataDisplay">
        <app-menu-item [item]="item" [collapsed]="sideNavCollapsed()"></app-menu-item>
    </ng-container>
</mat-nav-list>
